module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    attrs: {
      "id": "registration"
    }
  }, [_c('h1', {
    staticClass: "title twotitle reversetitle"
  }, [_vm._v("報名")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("活動費用")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("個人報名： 6500 元 / 人")]), _vm._v(" "), _c('li', [_vm._v("\n        團體報名： 5900 元 / 人\n        "), _c('br'), _vm._v(" 三人同時報名，視為團體報名，每團以三人為限，請詳閱\n        "), _c('a', {
    attrs: {
      "href": "./assets/document/SITCON_camp_2017_Registration_brochure.pdf",
      "target": "_blank"
    }
  }, [_vm._v("活動報名簡章")]), _vm._v("。\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        本次夏令營招收學員 60 名，我們會針對報名資料做簡易審查，非先報先贏。\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        正取學員名單將於 2017 / 06 / 15 公佈，正取學員需完成報名費繳交，始完成報名程序。\n      ")]), _vm._v(" "), _c('li', [_vm._v("另設有補助名額，請詳閱\n        "), _c('a', {
    attrs: {
      "href": "./assets/document/SITCON_camp_2017_Registration_fee_reduction.pdf",
      "target": "_blank"
    }
  }, [_vm._v("補助辦法")]), _vm._v("。")])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("報名時間")]), _vm._v(" "), _c('p', {
    staticClass: "info center"
  }, [_c('del', [_vm._v("即日起至 2017 / 06 / 05 止")])]), _vm._v(" "), _c('p', {
    staticClass: "info center"
  }, [_c('del', [_vm._v("好評再度加開，延長至 2017 / 06 / 12 止")])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "button"
  }, [_vm._v("已結束報名")])])]), _vm._v(" "), _c('div', {
    staticClass: "content row separate-around wrap"
  }, [_c('div', {
    staticClass: "items"
  }, [_c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("活動時間")]), _vm._v(" "), _c('p', {
    staticClass: "info center"
  }, [_vm._v("8/14（一）~ 8/17（四）")])]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('h2', {
    staticClass: "subtitle bluecar"
  }, [_vm._v("活動地點")]), _vm._v(" "), _c('p', {
    staticClass: "info center"
  }, [_vm._v("東海大學")]), _vm._v(" "), _c('p', {
    staticClass: "info center"
  }, [_vm._v("台中市西屯區台灣大道四段1727號")])])]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle redcar"
  }, [_vm._v("注意事項")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("\n      本次活動採用 KKTIX 售票進行報名，請詳細閱讀\n      "), _c('a', {
    attrs: {
      "href": "./assets/document/SITCON_camp_2017_Registration_brochure.pdf",
      "target": "_blank"
    }
  }, [_vm._v("活動報名簡章")]), _vm._v("。\n    ")]), _vm._v(" "), _c('li', [_vm._v("正式取得學員資格後不得轉讓予他人使用，轉讓者將取消資格。")]), _vm._v(" "), _c('li', [_vm._v("繳費完成始完成報名程序，正取學員若未於期限內繳交報名費用，將取消資格，由備取者遞補。")]), _vm._v(" "), _c('li', [_vm._v("錄取通知以及行前注意等資訊，均將透過報名時所留下之電子郵件通知學員，請務必定期檢查信箱，以確保個人權益。")]), _vm._v(" "), _c('li', [_vm._v("團體報名不保證所有團員皆錄取，唯團報經錄取者，皆可享有團體報名優惠。")]), _vm._v(" "), _c('li', [_vm._v("有任何問題歡迎來信至\n      "), _c('a', {
    attrs: {
      "href": "mailto:ask@sitcon.camp"
    }
  }, [_vm._v("ask@sitcon.camp")]), _vm._v("，我們將儘速回覆您。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-516b8deb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Registration.vue
// module id = 88
// module chunks = 0